import { IUnlockCode, IUnlockCodeErrorDetail } from "./useUnlockCodesState";

export const generateUnlockCodeErrorDetail = (
  unlockCodeObj: IUnlockCode,
  unlockCodes: IUnlockCode[],
  otherExistingUnlockCodes: string[] = []
): IUnlockCodeErrorDetail => {
  let unlockCodeError: string | undefined;
  if (unlockCodeObj.unlockCode.length === 0) {
    unlockCodeError = "This field is required.";
  } else if (
    unlockCodes.some(
      el =>
        el.componentKey !== unlockCodeObj.componentKey &&
        el.unlockCode === unlockCodeObj.unlockCode
    )
  ) {
    unlockCodeError = "Unlock Codes must be unique per coupon.";
  } else if (
    otherExistingUnlockCodes.some(
      el_unlockCode => el_unlockCode === unlockCodeObj.unlockCode
    )
  ) {
    unlockCodeError = "Unlock Codes must be unique per coupon.";
  } else {
    unlockCodeError = undefined;
  }

  const errorDetail = {
    couponReportTags:
      unlockCodeObj.couponReportTags.length === 0
        ? "This field is required."
        : undefined,
    description:
      unlockCodeObj.description.length === 0
        ? "This field is required."
        : undefined,
    unlockCode: unlockCodeError
  };
  return errorDetail;
};

export const hasError = (
  unlockCodeErrorDetail: IUnlockCodeErrorDetail
): boolean => {
  if (unlockCodeErrorDetail === undefined) {
    return false;
  }
  return Object.keys(unlockCodeErrorDetail).some(
    unlockCodeErrorField =>
      unlockCodeErrorDetail[unlockCodeErrorField] !== undefined
  );
};

export const generateCardBorderColor = (
  unlockCodeObj: IUnlockCode,
  unlockCodeErrorDetail: IUnlockCodeErrorDetail
): string => {
  if (hasError(unlockCodeErrorDetail)) {
    return "#EC5D77";
  }
  if (
    !!unlockCodeObj.unlockCode ||
    !!unlockCodeObj.couponReportTags.length ||
    !!unlockCodeObj.description
  ) {
    return "#0030FF";
  }
  return "#F1F2F3";
};

export const generateCollapsedCardErrorText = (
  errorDetail: IUnlockCodeErrorDetail
) => {
  const displayErrorText =
    errorDetail?.couponReportTags ??
    errorDetail?.description ??
    errorDetail?.unlockCode ??
    "";
  if (displayErrorText === "This field is required.") {
    return "Please fill up the required fields!";
  }
  return displayErrorText;
};
